export default "__VITE_ASSET__BbUYPdiM__"